import { PayloadAction } from '@reduxjs/toolkit';
import { IBrokerSignup } from '../../broker/interfaces/IBrokerSignup';

export const BrokerSignupReducer = {
	setBrokerSignup: (state: IBrokerSignup, action: PayloadAction<IBrokerSignup>) => {
		state.receitaResponse = action.payload.receitaResponse;
		state.user = action.payload.user;
		state.brokerAddress = action.payload.brokerAddress;
		state.bank = action.payload.bank;
		state.general = action.payload.general;
		state.files = action.payload.files;
	},
};
